import { useState, useEffect } from 'react'
import FlashSuccess from './FlashSuccess.jsx'
import FlashError from './FlashError.jsx'
import FlashAlert from './FlashAlert.jsx'
import FlashInfo from './FlashInfo.jsx'
import FlashDefault from './FlashDefault.jsx'

export default function Flash({message, type, timer}) {
  const [alertId, setAlertId] = useState("flash-" + Math.trunc(Math.random() * 10000000).toString());

  const handleDismissFlash = () => {
    document.getElementById(alertId).classList.add("hidden")
  }

  useEffect(() => {
    if (timer) {
      const timerId = setTimeout(() => {
        handleDismissFlash()
      }, timer);

      return () => clearTimeout(timerId);
    }
  });

  const buildMessageByType = () => {
    switch (type) {
      case 'success':
        return <FlashSuccess id={alertId} message={message} timer={timer} onDismissClick={handleDismissFlash}/>;
        break;
      case 'error':
        return <FlashError id={alertId} message={message} timer={timer} onDismissClick={handleDismissFlash}/>;
        break;
      case 'alert':
        return <FlashAlert id={alertId} message={message} timer={timer} onDismissClick={handleDismissFlash}/>;
        break;
      case 'info':
        return <FlashInfo id={alertId} message={message} timer={timer} onDismissClick={handleDismissFlash}/>;
        break;
      default:
        return <FlashDefault id={alertId} message={message} timer={timer} onDismissClick={handleDismissFlash}/>;
    }
  }

  return(
    <>{buildMessageByType()}</>
  )
}
